import React from 'react';

import useSession from 'hooks/useSession';
import Urls from 'configs/urls';

function ExportGroup(props) {
	const {
		disabled
	} = props;
	const {
		session
	} = useSession();

	//+ (disabled ? ' disabled' : '')
	return (
		<a
			href={Urls.baseExport.replace(':sessionId', session)}
			rel="noreferrer"
			target="_blank"
		>
			<button
				className={'btntool btn btn-primary p-0' }
				type="button"
			>
				<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none"
				     strokeLinecap="round" strokeLinejoin="round" className="css-i6dzq1">
					<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
					<polyline points="7 10 12 15 17 10"></polyline>
					<line x1="12" y1="15" x2="12" y2="3"></line>
				</svg>
			</button>
		</a>
	);
}

export default ExportGroup;
